import script from "./CongratulationsCertificateView.vue?vue&type=script&setup=true&lang=js"
export * from "./CongratulationsCertificateView.vue?vue&type=script&setup=true&lang=js"

import "./CongratulationsCertificateView.vue?vue&type=style&index=0&id=80e609a6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-80e609a6"]])

export default __exports__